module.exports = __webpack_public_path__ + "static/media/google_cloud_logo.584f8440.png";